<template>
  <div class="blank-wizard-container">
    <StepsH v-if="layoutH && showSteps" :steps="steps" />
    <!-- <StepsV v-if="!layoutH && showSteps" :steps="steps" /> -->

    <Step0 v-if="blankWelcome" />
    <Step7 v-if="blankAlreadyFilled" />
    <!-- {{ blankWelcome }}
    {{ showSteps }}
    {{ blankAlreadyFilled }}
    {{blank}} -->
  </div>
</template>

<script>
const StepsH = () => import('@/components/Blank/StepsH')
// const StepsV = () => import('@/components/Blank/StepsV')
const Step0 = () => import('@/components/Blank/Step0')
const Step7 = () => import('@/components/Blank/Step7')

// import { get, sync } from "vuex-pathify";
// import store from "@/store/store";
import { get } from 'vuex-pathify'

export default {
  components: {
    StepsH,
    // StepsV,
    Step0,
    Step7
  },
  computed: {
    // currentStep: sync("blank/data@currentStep"),
    // currentStep() {
    //   return store.get("blank/data@currentStep")
    // },
    currentStep: get('blank/data@currentStep'),
    blank: get('blank/data'),
    steps: get('blank/steps'),
    blankWelcome() {
      if (this.blankAlreadyFilled) {
        return false
      }
      return this.currentStep == null || this.currentStep == 0
    },
    showSteps() {
      return !this.blankWelcome && !this.blankAlreadyFilled
    },
    blankAlreadyFilled() {
      return this.currentStep >= 7
    },
    layoutH() {
      return true
    }
    // layoutH: get('layoutH')
  }
  // methods: {
  //   finishedStep0(nip) {
  //     // this.Step0 = false
  //     store.set("blank/data@nip", nip);
  //     store.set("blank/data@currentStep", 1);
  //   }
  // }
}
</script>
